<template>
  <transition name="fade">
    <div id="three_popups" v-on:click="$store.commit('newMessage')">
      <div class="wrapper">
        <div class="popup_blocks">
          <div :class="settings[type].class" class="popup_block">
            <div class="close" v-on:click="$store.commit('newMessage')"></div>
            <div class="popup_icon">
              <img :src="settings[type].icon">
            </div>
            <div class="name_popup">{{messageTitle}}</div>
            <p>{{message}}</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ["type", "message", "messageTitle"],
  data() {
    return {
      settings: {
        success: {
          icon: "/vue/images/successful_icon.png",
          class: "popup_block_successful"
        },
        error: {
          icon: "/vue/images/error_icon.png",
          class: "popup_block_error"
        },
        attention: {
          icon: "/vue/images/attention_icon.png",
          class: "popup_block_attention"
        }
      }
    };
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/modals/messages/alert-message.vue